import { useLayoutEffect, useState } from 'react';
import { createPortal } from 'react-dom';

interface PortalProps {
  children: React.ReactNode;
}

export const Portal: React.FC<PortalProps> = ({ children }) => {
  const [container] = useState(() => document.createElement('div'));

  // useLayoutEffect (not useEffect) so the container is attached before
  // consumers run their own layout effects that measure portaled children
  // (e.g. StatusSelect measuring dropdown height to flip above the viewport edge).
  useLayoutEffect(() => {
    document.body.appendChild(container);
    return () => {
      document.body.removeChild(container);
    };
  }, [container]);

  return createPortal(children, container);
};